async function hashString(value: string): Promise<string> {
  if (!value || value === 'undefined') {
    return value
  }

  const encoder = new TextEncoder()
  const data = encoder.encode(value.toLowerCase().trim())
  const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export async function hashUserData(
  userData: Record<string, unknown>
): Promise<Record<string, unknown>> {
  const result: Record<string, unknown> = {}

  await Promise.all(
    Object.entries(userData).map(async ([key, value]) => {
      if (key === 'city' || key === 'postal_code') {
        result[key] = value
        return
      }
      result[key] = typeof value === 'string' ? await hashString(value) : value
    })
  )

  return result
}
